import React from 'react'

import { Stack } from '@mui/material'

import { TextSizeCard } from './TextSizeCard'
import { ThemeCard } from './ThemeCard'

/**
 * Settings → Personal → Appearance.
 *
 * "Appearance", not "Theme", for the same reason Controls is not "Keyboard
 * shortcuts": the page is named for what it holds generally, so it can take the
 * next occupant without a rename that breaks the route and everyone's muscle
 * memory. It arrives already holding two things — theme and text size — which
 * is exactly why "Theme" would have been wrong on day one.
 *
 * Theme MOVED here from Profile rather than being copied. Profile is who you
 * are (photo, name, contact, login); how the app looks on this screen was never
 * part of that, and two homes for one control is two places to keep in step.
 *
 * Order is deliberate: theme first because it is the one people come looking
 * for, text size second because it is the newer, less-expected control.
 */
export const AppearancePage = () => (
  // 32px between stacked section cards, matching Profile and Company General. This was
  // spacing={4} (16px), which put Appearance's two cards half as far apart as Profile's four —
  // visible the moment you move between the two pages in the same sub-nav.
  <Stack spacing={8}>
    <Stack>
      <ThemeCard />
    </Stack>
    <Stack>
      <TextSizeCard />
    </Stack>
  </Stack>
)
